import { apiFuns } from "sw-hic";
let { genStandard } = apiFuns;
let api = {
  PrintTemplate: genStandard("printTemplate", "/api/md"),
  Attachment: {
    ...genStandard("attachment", "/api/store"),
    download: (id, name) => apiFuns.download(`/api/store/attachment/${id}/file`, {}, name),
  },
};
export default api;
